"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "accent", {
  enumerable: true,
  get: function get() {
    return _accent["default"];
  }
});
Object.defineProperty(exports, "action", {
  enumerable: true,
  get: function get() {
    return _action["default"];
  }
});
Object.defineProperty(exports, "background", {
  enumerable: true,
  get: function get() {
    return _background["default"];
  }
});
Object.defineProperty(exports, "error", {
  enumerable: true,
  get: function get() {
    return _error["default"];
  }
});
Object.defineProperty(exports, "greyscale", {
  enumerable: true,
  get: function get() {
    return _greyscale["default"];
  }
});
Object.defineProperty(exports, "opacity", {
  enumerable: true,
  get: function get() {
    return _opacity["default"];
  }
});
Object.defineProperty(exports, "primary", {
  enumerable: true,
  get: function get() {
    return _primary["default"];
  }
});
Object.defineProperty(exports, "secondary", {
  enumerable: true,
  get: function get() {
    return _secondary["default"];
  }
});
Object.defineProperty(exports, "text", {
  enumerable: true,
  get: function get() {
    return _text["default"];
  }
});

var _accent = _interopRequireDefault(require("./accent"));

var _action = _interopRequireDefault(require("./action"));

var _background = _interopRequireDefault(require("./background"));

var _error = _interopRequireDefault(require("./error"));

var _greyscale = _interopRequireDefault(require("./greyscale"));

var _opacity = _interopRequireDefault(require("./opacity"));

var _primary = _interopRequireDefault(require("./primary"));

var _secondary = _interopRequireDefault(require("./secondary"));

var _text = _interopRequireDefault(require("./text"));